import { render } from "./record-dialog.vue?vue&type=template&id=158cf9df&scoped=true"
import script from "./record-dialog.vue?vue&type=script&lang=js"
export * from "./record-dialog.vue?vue&type=script&lang=js"

import "./record-dialog.vue?vue&type=style&index=0&id=158cf9df&lang=scss&scoped=true"

import exportComponent from "D:\\lpl\\szy\\cloud-api-web-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-158cf9df"]])

export default __exports__